import { MButton2, MCheckbox, MInput, MLabel, MSearchAteneo, MSearchSchool, MSelect, MToggle, ValidatedForm } from "components/forms";
import { QUALIFICATION_CODE } from "const";
import { Col, Row } from "design-react-kit";
import { dateHelper, payloadBuilder } from "libs";
import React from "react";

export class FormTitleTFAIndire extends ValidatedForm {
  emptyFields = {
    description: "",
    istitution: "",
    city: "",
    aa: "",
    votoTitolo: "",
    titleType: "",
    lode: "",
    baseVote: 110,
    dataConseguimento: "",
    contactName: "",
    contactFax: "",
    contactPhone: "",
    contactEmail: "",
    contactPec: "",
  };

  state = {
    isForeign: false,
    showSearchAteneo: false,
    showButtonAteneo: false,
    showSearchSchool: false,
    ateneo: {},
    school: {},
    ...this.emptyFields,
    defaultValues: {
      ...this.emptyFields,
    },
    currentType: "",
  };

  ERROR_MESSAGES = {
    istitution: "Dato obbligatorio",
    description: "Dato obbligatorio",
    dataConseguimento: "Dato obbligatorio",
    titleType: "Dato obbligatorio",
    aa: "Inserire l'anno accademico in formato AAAA/AAAA",
    nation: "Dato obbligatorio",
    city: "Dato obbligatorio",
    votoTitolo: "Dato obbligatorio",
    baseVote: "Dato obbligatorio",
  };

  validation = {
    istitution: (value) => value !== "",
    city: (value) => value !== "",
    description: (value) => value !== "",
    titleType: (value) => value !== "",
    votoTitolo: (value) => this.validateVote(value),
    dataConseguimento: (value) => this.validateDataConseguimento(value),
    aa: (value) => this.validateAA(value),
    nation: (value) => value !== "",
    baseVote: (value) => this.validateBaseVote(value),
  };

  getTitleTypes = (grado) => {
    const options = [{ value: "", label: "Seleziona il tipo di titolo" }];

    const primoGradoOptions = Object.keys(QUALIFICATION_CODE).map((key) => ({
      value: key,
      label: QUALIFICATION_CODE[key],
    }));

    switch (grado) {
      case "PRIMARIA":
        options.push(
          {
            value: "LaureaScienzeFormazionePrimariaVO",
            label: "Laurea in Scienze della Formazione primaria Legge 341/1990 (vecchio ordinamento)",
          },
          { value: "LaureaScienzeFormazionePrimaria249", label: "Laurea in scienze della Formazione primaria DM 240/2010 classe LM-85 bis" },
          {
            value: "DiplomaMagistrale0102",
            label:
              "Diploma magistrale conseguito entro a.s. 2001/02, dichiarato abilitante con D.P.R. del 25 marzo 2014 (pubb. in G.U. del 15 maggio 2014)",
          },
          {
            value: "DiplomaSperimentale0102_Psico",
            label:
              "Diploma sperimentale a indirizzo psicopedagogico, con valore abilitante, conseguito entro a.s. 2001/02 e presso istituti magistrali",
          },
          {
            value: "DiplomaSperimentale0102_Ling",
            label: "Diploma sperimentale a indirizzo linguistico, con valore abilitante, conseguito entro a.s. 2001/02 e presso istituti magistrali",
          },
        );

        break;

      case "I GRADO":
        options.push(...primoGradoOptions);
        break;

      // II grado: I grado options + ITP
      case "II GRADO":
        options.push(...primoGradoOptions, {
          value: "ITP",
          label:
            "Secondo grado - ITP - Insegnante Tecnico Pratico con diploma di scuola secondaria di secondo grado ai sensi della normativa vigente in materia di concorso",
        });
        break;

      default:
        break;
    }

    return { options };
  };

  getFields = (step) => {
    switch (step) {
      case "step1":
        return [
          [
            {
              id: "titleType",
              field: "titleType",
              label: "Tipo di titolo",
              component: MSelect,
              payload: this.getTitleTypes(this.props.grado),
              className: "col-md-12",
              onChange: (_, value) => this.onChangeTitleType(_, value),
            },
          ],
        ];

      case "step2":
        return [
          [
            {
              id: "istitution3",
              field: "istitution",
              label: "Presso",
              component: MInput,
              type: "text",
              className: "col-md-6",
              readOnly: true,
            },
            {
              id: "city3",
              field: "city",
              label: "Città",
              component: MInput,
              type: "text",
              className: "col-md-6",
              readOnly: true,
            },
          ],
          [
            {
              id: "description3",
              field: "description",
              label: "Titolo conseguito",
              component: MInput,
              type: "text",
              className: "col-md-12",
            },
          ],
          [
            {
              id: "aa3",
              field: "aa",
              label: "Anno accademico",
              component: MInput,
              type: "text",
              className: "col-md-4",
            },
            {
              id: "dataConseguimento3",
              field: "dataConseguimento",
              label: "Data conseguimento",
              component: MInput,
              type: "date",
              className: "col-md-4",
            },
          ],
          [
            {
              id: "votoTitolo3",
              field: "votoTitolo",
              label: "Voto",
              component: MInput,
              type: "text",
              className: "col-md-4",
            },
            {
              id: "baseVote3",
              field: "baseVote",
              label: "Base Voto",
              component: MInput,
              type: "text",
              className: "col-md-4",
            },
            {
              id: "lode",
              name: "lode",
              field: "lode",
              label: "Lode",
              component: MCheckbox,
              className: "col-md-4",
              infoText: "puoi selezionare la lode quando Voto e Base Voto sono uguali",
              onChange: () => this.onChangeLode(),
            },
          ],
          [
            {
              field: "optionalInfo",
              label: "Informazioni facoltative:",
              infoText:
                "Informazioni per la verifica dei dati ex articolo 15, comma 1, punto e della legge 183/2011. Recapiti della segreteria competente.",
              component: MLabel,
              className: "col-md-12",
            },
          ],
          [
            {
              id: "contactName3",
              field: "contactName",
              label: "Denominazione",
              component: MInput,
              type: "text",
              className: "col-md-12",
            },
          ],
          [
            {
              id: "contactPhone3",
              field: "contactPhone",
              label: "Telefono",
              component: MInput,
              type: "text",
              className: "col-md-6",
            },
            {
              id: "contactFax3",
              field: "contactFax",
              label: "Fax",
              component: MInput,
              type: "text",
              className: "col-md-6",
            },
          ],
          [
            {
              id: "contactEmail3",
              field: "contactEmail",
              label: "Email",
              component: MInput,
              type: "text",
              className: "col-md-6",
            },
            {
              id: "contactPec3",
              field: "contactPec",
              label: "Pec",
              component: MInput,
              type: "text",
              className: "col-md-6",
            },
          ],
        ];

      default:
        return [];
    }
  };

  normalize = (v) => {
    if (!v) return "";
    if (typeof v === "object" && v.value !== undefined) return v.value;
    return v;
  };

  validateAA = (value) => {
    //--- reset dataConseguimento ---
    this.setState({ dataConseguimento: "" });

    let aa = /^(\d{4})\/(\d{4})$/.test(value);

    if (!aa) {
      return false;
    } else {
      aa = value.split("/");

      const startYear = parseInt(aa[0]);
      const endYear = parseInt(aa[1]);

      if (endYear > new Date().getFullYear()) {
        return false;
      }

      if (endYear !== startYear + 1) {
        return false;
      }

      return true;
    }
  };

  validateDataConseguimento = (value) => {
    if (value === "") {
      return false;
    }
    let regex = /^\d{4}-\d{2}-\d{2}$/;

    if (!value.match(regex)) {
      return false;
    }
    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return false;
    }
    const [year, month, day] = value.split("-").map(Number);

    if (month > 12) {
      return false;
    }
    if (day > 31) {
      return false;
    }

    const noFuture = dateHelper.noFuture(value);
    if (noFuture === false) {
      return false;
    }

    const currentYear = new Date().getFullYear();
    if (year < currentYear - 70 || year > currentYear) {
      return false;
    }

    const aa = this.normalize(this.state.aa);

    //--- guard on compliant AA --
    if (aa) {
      const aaSplit = aa.split("/");
      const firstDate = new Date(`${parseInt(aaSplit[1])}-03-01`);
      const secondDate = new Date(`${parseInt(aaSplit[1]) + 1}-04-30`);

      if (date < firstDate || date > secondDate) {
        return false;
      }
    }

    return true;
  };

  validateBaseVote = (value) => {
    this.onChangeLode();

    if (value === "") return false;
    if (isNaN(value)) return false;

    if (value < 60 || value > 110) return false;

    return true;
  };

  validateVote = (value) => {
    const baseVote = this.normalize(this.state.baseVote);

    this.onChangeLode();
    if (value === "") {
      return false;
    }

    if (isNaN(value)) {
      return false;
    }

    if (baseVote === "" || !baseVote) {
      return false;
    }

    if (baseVote === "100") {
      if (value > 100 || value < 60) {
        return false;
      }
    }

    if (baseVote === "60") {
      if (value > 60 || value < 36) {
        return false;
      }
    }

    return true;
  };

  componentDidMount() {
    const { defaultPayload } = this.props;

    if (defaultPayload && defaultPayload.length > 0) {
      const title = defaultPayload[0];

      this.setState(
        {
          ...title,
          titleType: title.template,
          defaultValues: {
            ...this.state.defaultValues,
            ...title,
            titleType: title.template,
          },
        },
        () => {
          if (title.template) {
            this.onChangeTitleType(null, title.template);
          }
        },
      );
    }
  }

  onChangeAteneo = (ateneo) => {
    this.onChange("city", ateneo.city);
    this.onChange("istitution", ateneo.istitution);

    this.setState({ showSearchAteneo: false, ateneo: ateneo });
  };

  onChangeSchool = (school) => {
    this.onChange("city", school.city);
    this.onChange("istitution", school.istitution);
    this.onChange("province", school.province);
    this.onChange("address", school.address);
    this.setState({ showSearchSchool: false, school: school });
  };

  onChangeTitleType = (_, value) => {
    const schoolValues = ["ITP", "DiplomaMagistrale0102", "DiplomaSperimentale0102_Psico", "DiplomaSperimentale0102_Ling"];

    const isAfam = value === "AFAM";
    const isSchool = schoolValues.includes(value);
    const isAteneo = value !== "" && !isSchool;

    this.setState({
      titleType: value,
      currentType: isAfam ? "afam" : "uni",
      defaultValues: { ...this.state.defaultValues, titleType: value },
      showButtonSchool: isSchool,
      showButtonAteneo: isAteneo,
      showSearchAteneo: false,
      showSearchSchool: false,
      istitution: "",
      city: "",
    });
  };

  onChangeLode = () => {
    const votoTitolo = this.normalize(this.state.votoTitolo);
    const baseVote = this.normalize(this.state.baseVote);

    if (isNaN(votoTitolo) || isNaN(baseVote) || votoTitolo === "" || baseVote === "" || parseInt(votoTitolo) !== parseInt(baseVote)) {
      this.setState({ lode: { value: false, isValid: true } });
      return false;
    }

    return true;
  };

  searchAteneo = () => {
    this.setState({ showSearchAteneo: !this.state.showSearchAteneo });
  };

  searchSchool = () => {
    this.setState({ showSearchSchool: !this.state.showSearchSchool });
  };

  onSubmit = () => {
    let isValid = true;
    isValid = this.checkValidation();

    return isValid;
  };

  getPayload = () => {
    const { ateneo, school, titleType } = this.state;

    this.payload = payloadBuilder(this.state);

    const payloadTitleType = titleType && typeof titleType === "object" ? titleType.value : titleType;

    const { options } = this.getTitleTypes(this.props.grado);
    const selectedOption = options.find((opt) => opt.value === payloadTitleType);
    const qualificationLabel = selectedOption ? selectedOption.label : payloadTitleType;

    this.payload.qualificationType = qualificationLabel;
    this.payload.qualificationCode = "title13";
    this.payload.template = payloadTitleType;

    if (ateneo && ateneo.uniCode) {
      this.payload.nation = ateneo.nation;
      this.payload.uniCode = ateneo.uniCode || "";
    } else if (school && school.schoolCode) {
      this.payload.nation = "Italia";
      this.payload.uniCode = school.schoolCode;
    }

    return this.payload;
  };

  render() {
    const { showSearchAteneo, showSearchSchool, showButtonAteneo, showButtonSchool, defaultValues, currentType } = this.state;

    const codeStep1 = this.renderFields(this.getFields("step1"), defaultValues, true).code;
    const codeStep2 = this.renderFields(this.getFields("step2"), defaultValues, true).code;

    return (
      <>
        {showSearchAteneo && (
          <div className="p-4 border border-secondary rounded-lg">
            <MSearchAteneo type={currentType} onChange={this.onChangeAteneo} searchAteneo={this.searchAteneo} />
          </div>
        )}

        {showSearchSchool && (
          <>
            <MSearchSchool onChange={this.onChangeSchool} searchSchool={this.searchSchool} />
          </>
        )}

        <form className="user mt-5">
          {codeStep1}

          <Row className="mb-5">
            {showButtonAteneo && (
              <Col md={12}>
                <MButton2 label="Cerca Ateneo" className="mb-3" classElement="btn btn-primary bg-dark" onClick={this.searchAteneo} />
              </Col>
            )}

            {showButtonSchool && (
              <Col md={12}>
                <MButton2 label="Cerca Scuola" className="mb-3" classElement="btn btn-primary bg-dark" onClick={this.searchSchool} />
              </Col>
            )}
          </Row>

          {codeStep2}
        </form>
      </>
    );
  }
}
